module.exports = __webpack_public_path__ + "img/home phone.2da787b0.png";